import { FLAG } from "../constants/Constants";

/**
 * このファイルにはUserOptionテーブルの列に関わる処理を定義しています。
 * TODO utils/utils.jsにユーザー関連が多くあるので、本ファイルに移行する
 */

/**
 * レターのAI昨機能が使用可能かどうかを判定
 *
 * @param {object} user ユーザー
 * @return {bool} true: 可能, false: 不可
 */
export const isEnableLetterAI = (user) => {
  return user ? (user.letter_ai_flag === FLAG.ON) : false;
}

/**
 * 添付物がアップロードできるかどうかを判定
 * @param {object} user ユーザー
 * @return {bool}
 */
export const isEnableUploadAdditionalFile = (user) => {
  return user ? (user.can_upload_additional_file === FLAG.ON) : false;
}

/**
 * 1通送付できるかどうかを判定
 * @param  {object} user ユーザー
 * @return {bool}
 */
export const isEnableSendOneLetter = (user) => {
  return user ? (user.min_letter_order_count === null || user.min_letter_order_count === 1) : false;
}

/**
 * 自社リストに対してフォローコールを依頼できるか判定
 * @param {object} user
 * @returns {bool}
 */
export const isEnableFollowCallHouseList = (user) => {
  return user ? (user.can_follow_call_house_list === FLAG.ON) : false;
}

/**
 * コール履歴をダウンロードできるか判定
 * @param {object} user
 * @returns {bool}
 */
export const isEnableDownloadCallHistory = (user) => {
  return user ? (user.can_download_call_history === FLAG.ON) : false;
}

/**
 * Salesforceに連携できるか判定
 * @param {object} user
 * @returns {bool}
 */
export const isIntegrateSalesforce = (user) => {
  return user ? (user.salesforce_integration_flag === FLAG.ON) : false;
}

/**
 * タイムラインをSalesforceの活動(Event)に連携できるか判定
 * @param {object} user
 * @returns {bool}
 */
export const isIntegrateSalesforceTimelineStatus = (user) => {
  return user ? (user.salesforce_integration_timeline_status_flag === FLAG.ON) : false;
}

/**
 * キーマン検索の表示人数を制限するかどうかを判定
 * @param {object} user ユーザー
 * @returns {boolean} キーマン検索の表示人数を制限するかどうか
 */
export const isEnableCapSizeFilter = (user) => {
  return user && (user.cap_search_flag === 1);
}

/**
 * オペレーター用絞り込み機能を使用可能かどうかを判定
 * @param {object} user ユーザー
 * @returns {boolean} オペレーター用絞り込み機能を使用可能かどうか
 */
export const isEnableKLOperatorAdvancedSearch = (user) => {
  // TODO 現在はIDベタ書きで実装している
  const csFlagChildId = 11471;
  const keymanCallId = 1709;
  const customTargetUserId = 1;  // 不要になったら削除すること
  const enableUserIds = [csFlagChildId, keymanCallId, customTargetUserId];
  return user ? (enableUserIds.includes(user.id)) : false;
}

/**
 * 法人番号AI付与機能を使用可能かどうかを判定
 * 全ユーザーに解放しているため、ログイン済みであれば常にtrueを返す
 * @param {object} user ユーザー
 * @returns {boolean} 法人番号AI付与機能を使用可能かどうか
 */
export const isEnableCorporateNumberAssign = (user) => {
  return user ? true : false;
}

/**
 * 追加ファイル(PDF)の最大ページ数を解決
 * @param {object} user ユーザー
 * @return {number}
 */
export const resolveAdditionalFileMaxPages = (user) => {
  const gettyUserId = 6131;
  const defaultMaxPageCount = 2;
  const userMaxPageCounts = [
    { user_id: gettyUserId, max_page_count: 4 },
  ];

  if (!user) {
    return defaultMaxPageCount;
  }

  const matched = userMaxPageCounts.find((item) => (
    item.user_id === user.id || item.user_id === user.parent_id
  ));
  if (matched) {
    return matched.max_page_count;
  }

  return defaultMaxPageCount;
}



// WEBPACK FOOTER //
// ./src/utils/userOptionUtils.js